import { createControlFn } from "../create-control-fn"

const controlSurnameFieldFn = createControlFn({
  filterValueCb: (value) =>
    !/^\s+/.test(value) && !/[^a-zA-Z-' àáèéìíòóùú]/.test(value),
})

export { controlSurnameFieldFn }
